export interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
  keywords: string[];
  image: string;
}

export const categories: Category[] = [
  {
    id: "cat-ent",
    name: "娱乐动态",
    icon: "ri-music-2-line",
    count: 428,
    desc: "巡演、组合动向、活动行程，按时间线串起来看，不错过任何一个节点。",
    keywords: ["艺人行程", "组合动态", "巡演开票"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20light%20streaks%20in%20coral%20and%20gold%2C%20vertical%20editorial%20composition%2C%20soft%20glow%2C%20no%20text&width=600&height=800&seq=cat-ent-01&orientation=portrait",
  },
  {
    id: "cat-film",
    name: "影视前线",
    icon: "ri-film-line",
    count: 316,
    desc: "新剧官宣、档期变动、片场路透与口碑走向，一页看完一部作品的来龙去脉。",
    keywords: ["新剧官宣", "档期", "口碑"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20studio%20spotlight%20with%20teal%20and%20amber%20gradient%2C%20vertical%20cinematic%20composition%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=800&seq=cat-film-02&orientation=portrait",
  },
  {
    id: "cat-tech",
    name: "科技热点",
    icon: "ri-cpu-line",
    count: 264,
    desc: "发布会预热、新品参数、社区迁移方案，把技术圈正在吵的事讲成人话。",
    keywords: ["发布会", "新品", "开源"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20geometric%20technology%20pattern%20with%20fresh%20green%20and%20deep%20charcoal%2C%20vertical%20minimal%20composition%2C%20clean%20grid%2C%20no%20text&width=600&height=800&seq=cat-tech-03&orientation=portrait",
  },
  {
    id: "cat-sports",
    name: "体育现场",
    icon: "ri-basketball-line",
    count: 187,
    desc: "联赛战报、转会传闻、赛程提醒，胜负之外也看那些被忽略的细节。",
    keywords: ["联赛", "战报", "赛程"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stadium%20field%20lines%20under%20floodlights%2C%20vertical%20editorial%20composition%2C%20green%20turf%20and%20amber%20glow%2C%20no%20text&width=600&height=800&seq=cat-sports-04&orientation=portrait",
  },
  {
    id: "cat-society",
    name: "城市生活",
    icon: "ri-building-line",
    count: 342,
    desc: "活动报名、交通提醒、身边小事，和吃瓜无关但同样值得知道的那部分。",
    keywords: ["城市活动", "出行提醒"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20city%20skyline%20at%20dusk%20with%20warm%20coral%20and%20amber%20tones%2C%20vertical%20minimal%20composition%2C%20no%20text&width=600&height=800&seq=cat-society-05&orientation=portrait",
  },
];